<template>
  <section class="section--comp">
    <div class="container lg:w-4/5">
    <vx-card no-shadow card-background="#F7F8F9">
      <div class="tips-heading mb-base">5 Tips for re-purpose longer courses into short form content:</div>
      <ul class="tips-list">
        <li><vs-icon class="mr-3" color="#F29300" icon="icon-check-circle" icon-pack="feather"/>Only include one learning objective in each microlearning module.</li>
        <li><vs-icon class="mr-3" color="#F29300" icon="icon-check-circle" icon-pack="feather"/>Make use infographics that can be easily absorbed and visually remembered.</li>
        <li><vs-icon class="mr-3" color="#F29300" icon="icon-check-circle" icon-pack="feather"/>Simplify while communicating complex information.</li>
        <li><vs-icon class="mr-3" color="#F29300" icon="icon-check-circle" icon-pack="feather"/>Only include “must know” concepts, extension to topic can be provided as references.</li>
        <li><vs-icon class="mr-3" color="#F29300" icon="icon-check-circle" icon-pack="feather"/>Focus on explaining “how to apply" the skill.</li>
      </ul>
    </vx-card>
    </div>
  </section>
</template>

<script>
    export default {
        name: "Tips"
    }
</script>

<style scoped>
  /* section {
    padding: 7rem 20rem;
  } */

  .tips-heading {
    font-style: normal;
    font-weight: 800;
    font-size: 20px;
    line-height: 27px;
    color: #231D4F;
  }

  .tips-list li {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #231D4F;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 20px 0px;
  }


  /*@media (max-width: 1200px) {
    section {
      padding: 7rem 0;
    }
  } */
</style>
